export const isAdminAuthenticatedLocal = () =>
  localStorage.getItem('admin_authenticated') === 'true'

export const setAdminSession = (username) => {
  localStorage.setItem('admin_authenticated', 'true')
  if (username) {
    localStorage.setItem('admin_username', username)
  }
}

export const clearAdminSession = () => {
  localStorage.removeItem('admin_authenticated')
  localStorage.removeItem('admin_username')
}
